import React, { useState, useReducer, useEffect, useRef } from "react";
import { Button, Grid, Modal, Icon, Popup, Label } from "semantic-ui-react";
import {
  initialState,
  reducer,
  ACTION,
} from "../../../Reducer/InitialStateReducer";

import { server } from "../../../App";
import axios from "axios";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import MedicamentsHistoricUpdate from "./MedicamentsHistoricUpdate";
import MedicamentsHistoricRenouv from "./MedicamentsHistoricRenouv";

import { Editor } from "@tinymce/tinymce-react";
import { useSelector, useDispatch } from "react-redux";
import { selectCounters, Medicaments_Counter_Reducer } from "../../../features/counter/counterSlice";


function Medicaments(props) {
  const dispatchRedux = useDispatch();
  const CountersState = useSelector(selectCounters);
  const [state, dispatch] = useReducer(reducer, initialState);
  const [, setGridApi] = useState(null);
  const [, setGridColumnApi] = useState(null);
  const [rendezVous, setrendezVous] = useState("");
  const [dateModOrdonnance, setdateModOrdonnance] = useState("");

  const { ID, syncData, userInformation, AuthState } = props;

  const editorRef = useRef(null);

  let rows;
  rows = state.rowData;

  const objectToSend = {
    rows,
  };

  const columnDefs2 = [
    {
      headerName: "fk_id_patient_ordo_medic",
      field: "fk_id_patient_ordo_medic",
      editable: false,
      hide: true,
    },
    {
      headerName: "date_ordonance2",
      field: "date_ordonance2",
      editable: false,
      hide: true,
    },
    {
      headerName: "date",
      field: "date_ordonance",
      checkboxSelection: true,
    },

    // 1ere sous catégorie
  ];

  const defaultColDef2 = {
    sortable: true,
    // editable: true,
    // cellEditor: 'agLargeTextCellEditor',
    maxLength: 255,
    flex: 1,
    // filter stuff
    filter: true,
    // floatingFilter: true,
    // suppressMenu: true,
    // end of filter stuff
    minWidth: 100,
    // resizable: true,
    // tooltipComponent: 'customTooltip',
    filterParams: {
      newRowsAction: "keep",
      // buttons: ['apply', 'clear'],
    },
    resizable: true,
    cellClass: "cell-wrap-text",
    autoHeight: true,
  };

  async function getOneUser() {
    await axios
      .get(`${server}OrdonanceMedoc/GetAllOrdonance/${ID}`, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => {
        dispatchRedux(Medicaments_Counter_Reducer(response.data.length));
        dispatch({ type: ACTION.FETCH_SUCCESS2, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: ACTION.FETCH_ERROR, payload: error.response });
      });
  }

  useEffect(() => {
    getOneUser();
  }, [state.open]);

  const onGridReady = (params) => {
    setGridColumnApi(params.columnApi);
    setGridApi(params.api);
    params.api.setRowData(state.rowData);
  };

  const onSelectionChanged2 = (e) => {
    if (e.api.getSelectedRows()[0] === undefined) {
      const emptyCheckbox = {
        date_ordonance: "",
        date_ordonance2: "",
        fk_id_patient_ordo_medic: "",
        index: "",
        ordonnance_date3: "",
      };
      dispatch({
        type: ACTION.ORDONANCE_MEDICAMENTS_HISTORIC,
        value: emptyCheckbox,
      });
    } else {
      let clientArray = e.api.getSelectedRows()[0];
      let d, id;
      d = clientArray.date_ordonance2;
      id = clientArray.fk_id_patient_ordo_medic;
      getOneOrdonnance(d, id);

      const allRows = state.rowData2;
      let index = allRows.findIndex((x) => {
        if (
          x.id_ordonnance_medicaments ===
          clientArray.id_ordonnance_medicaments &&
          x.medicament === clientArray.medicament &&
          x.qte === clientArray.qte &&
          x.posologie === clientArray.posologie &&
          x.duree === clientArray.duree &&
          x.od === clientArray.od &&
          x.og === clientArray.og
        ) {
          return true;
        }
      });

      let ModclientArray = {
        ...clientArray,
        index: index,
      };

      dispatch({
        type: ACTION.ORDONANCE_MEDICAMENTS_HISTORIC,
        value: ModclientArray,
      });
    }
  };

  async function getOneOrdonnance(d, id) {
    await axios
      .get(`${server}OrdonanceMedoc/OrdonanceAtDate/${d}/${id}`, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => {
        dispatch({ type: ACTION.FETCH_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: ACTION.FETCH_ERROR, payload: error.response });
      });
  }

  const handleRemoveItem1 = async () => {
    axios({
      method: "DELETE",
      responseType: "json",
      url: `${server}OrdonanceMedoc/DeleteOneUserOrdonnance/${state.date_ordonance2}/${state.fk_id_patient_ordo_medic}`,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then(() => {
        // dispatch({ type: ACTION.DELETE_SUCCESS })
        getOneUser();
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };

  // console.log({ objectToSend });
  // const { rows } = objectToSend;
  let content;
  if (objectToSend.rows) {
    content = objectToSend.rows.map(
      (row, i) =>
        `<p class="mceNonEditable" style="padding-left: 2rem;line-height: 1;font-size:14px"><span style="text-decoration: underline;"><strong>
          ${i + 1}/ 
          ${row.medicament} ${row.od
          ? row.og
            ? " - Les Deux Yeux"
            : " - Oeil Droit"
          : row.og
            ? " - Oeil Gauche"
            : ""
        }
          ${row.qte ? `- ${row.qte}` : ""}
          </strong></span></p>
        <p class="mceNonEditable" style="padding-left: 3rem; font-size:14px">
          ${row.posologie ? row.posologie : ""}, ${row.duree ? row.duree : ""}
        </p>`
    );
  }

  let headerDate = `<h4 class="mceNonEditable" style="text-align: center;">${dateModOrdonnance ? `Le ${dateModOrdonnance}` : ""
    }</h4>`;
  let headerName = `<h4 class="mceNonEditable" style="text-align: center; margin: 2.5rem;">${userInformation?.civilite} ${userInformation?.nom} ${userInformation?.prenom}</h4>`;

  let rdvFooter = `<p style="padding-left: 2rem;line-height: 1;" class="mceNonEditable">${rendezVous ? `Prochain rendez-vous dans ${rendezVous}` : ""
    }</p>`;

  if (content) {
    content = content?.join(" ").toString();
  } else {
    content = "";
    rdvFooter = "";
  }

  let description = headerDate + headerName + content + rdvFooter;

  useEffect(() => {
    if (state?.rowData2) {
      setdateModOrdonnance(state?.rowData2[state.index]?.date_ordonance);
    } else {
      setdateModOrdonnance("");
    }
  }, [state?.rowData2, state.index]);
  useEffect(() => {
    if (state?.rowData2) {
      setrendezVous(state?.rowData2[state.index]?.rdv);
    } else {
      setrendezVous("");
    }
  }, [state?.rowData2, state.index]);

  let Contents = (
    <div>
      <Editor
        // apiKey="4wmks1hxrd175lnu674946w8nb95pzv263exeq2v73z02al0"
        tinymceScriptSrc={process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"}
        onInit={(evt, editor) => (editorRef.current = editor)}
        initialValue={description}
        init={{
          // selector: "textarea",
          branding: false,
          height: "70vh",
          menubar: false,
          noneditable_editable_class: "mceEditable",
          plugins: [
            "advlist autolink lists link image charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table paste code help ",
            "print",
            "noneditable",
          ],
          toolbar: " print  ",
          content_style:
            "@page {size: A5; margin-top: 3.8cm; margin-bottom: 2.2cm; margin-left:0.25cm; margin-right:0.25cm;} body{font-size:16px} ",
          setup: function (editor) {
            editor.on("keydown", function (event) {
              if (event.keyCode === 8 || event.keyCode === 46) {
                const currentLine = editor.selection.getNode();

                // Prevent deletion of non editable text
                if (
                  currentLine.hasAttribute("data-mce-bogus") ||
                  currentLine.className.includes("mceNonEditable")
                ) {
                  event.preventDefault();
                  event.stopPropagation();
                  return false;
                }
              }
            });
          },
        }}
      />
    </div>
  );

  return (
    <>
      <Popup
        content="Historique Ordo. Medic"
        trigger={
          <Button

            onClick={() => dispatch({ type: ACTION.OPEN, size: "fullscreen" })}
          >
            <Icon name="history" size="large" className="centerIcon" />
            {CountersState?.Medicaments_Counter === 0 ? null :
              <Label color='red' className="floatingnumber">
                {CountersState?.Medicaments_Counter}
              </Label>

            }
          </Button>
        }
      />

      <Modal
        size={state.size}
        open={state.open}
        onClose={() => dispatch({ type: ACTION.CLOSE })}
        className="lunettesModal"
      >
        <Modal.Header className="center3columnheaders">
          Historique des Ordonnances
        </Modal.Header>
        <Modal.Content>
          <Grid>
            <Grid.Column width={12}>{Contents}</Grid.Column>

            <Grid.Column width={4}>
              <div
                id="myGrid"
                className="ag-theme-alpine"
                style={{
                  height: "50vh",
                  width: "100%",
                }}
              >
                <AgGridReact
                  rowData={state.rowData2 ? state.rowData2 : []}
                  // rowData={[]}
                  animateRows={true}
                  sortingOrder={["desc", "asc", null]}
                  onGridReady={onGridReady}
                  columnDefs={columnDefs2}
                  defaultColDef={defaultColDef2}
                  rowSelection={"single"}
                  onSelectionChanged={onSelectionChanged2}
                  undoRedoCellEditing={true}
                  undoRedoCellEditingLimit={40}
                // onCellValueChanged={onCellValueChanged2}
                ></AgGridReact>
              </div>
              <br />
              <Grid.Row>
                {state.fk_id_patient_ordo_medic ? (
                  <>
                    <MedicamentsHistoricRenouv
                      ID={ID}
                      syncData={syncData}
                      option={15}
                      userInformation={userInformation}
                      objectToSend={objectToSend}
                      refreshOrdonnances={getOneUser}
                      AuthState={AuthState}
                    />
                    <MedicamentsHistoricUpdate
                      ID={ID}
                      syncData={syncData}
                      option={15}
                      userInformation={userInformation}
                      objectToSend={objectToSend}
                      refreshOrdonnances={getOneUser}
                      AuthState={AuthState}
                    />
                  </>
                ) : (
                  <>
                    <Button disabled color="blue">
                      <Icon name="edit" className="centerIcon" />
                    </Button>
                    <Button disabled color="green">
                      <Icon name="copy" className="centerIcon" />
                    </Button>
                  </>
                )}
                {state.fk_id_patient_ordo_medic ? (
                  <>
                    {/* <Button positive onClick={() => UpdateLunettesAttributes()} icon>
                                            <Icon name='save' />
                                        </Button> */}
                    {/* <button onClick={() => onRemoveSelected()}>Remove Selected</button> */}
                    <Button
                      className="margintopclass"
                      negative
                      onClick={() => handleRemoveItem1()}
                      floated="right"
                      icon
                    >
                      <Icon name="delete" />
                    </Button>
                  </>
                ) : (
                  <>
                    {/* <Button disabled positive onClick={() => UpdateLunettesAttributes()} icon>
                                            <Icon name='save' />
                                        </Button> */}

                    <Button className="margintopclass" disabled negative floated="right" icon>
                      <Icon name="delete" />
                    </Button>
                  </>
                )}
              </Grid.Row>
            </Grid.Column>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button color="blue" onClick={() => dispatch({ type: ACTION.CLOSE })}>
            Retour <Icon className="leftSpace" name="reply" />
          </Button>

          {/* {componentToShow} */}
        </Modal.Actions>
      </Modal>
    </>
  );
}

export default Medicaments;
